<template>
  <footer class="footer" :class="{ 'footer-full': isGlobalDashboard }">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 footer-copyright">
          <p class="mb-0">AOURIR Mohamed</p>
        </div>
        <div class="col-md-6">
          <p class="pull-right mb-0">
            Hand crafted & made with <i class="fa fa-heart"></i>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    // Tableau de bord global : la sidebar est masquée, le footer prend
    // toute la largeur comme le header.
    isGlobalDashboard() {
      return this.$route.path === "/dashboard/default";
    }
  }
};
</script>

<style scoped>
/* Tableau de bord global : la sidebar est masquée, le footer s'étend sur
   toute la largeur (la marge par défaut est de 255px à gauche). */
.footer-full {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>